import { SitemapsTable } from './sitemaps-table';

export { SitemapsTable };
